import { gql } from "@apollo/client";

export const INSERT_DISTRICT_REPORT = gql`
  mutation insertDistrictReport($districtReportInput: DistrictReportInput) {
    insertDistrictReport(districtReportInput: $districtReportInput) {
      id
      districtId
      userId
      isUserReport
      baseReportId
      reportCode
      reportName
      reportTitle
      reportGroup
      reportNotes
      reportRowNotes {
        rowId
        notes
      }
      reportParameters
      selectedFields {
        fieldName
        fieldGroup
        fieldCaption
        fieldOrder
        fieldWidth
        fieldAlignment
        dataType
        dataFormat        
        fieldHasFilter
        fieldHasSort
        visible
        default
        required
      }
      reportColumns
      reportTableFilters,
      reportTableSorter,
      grouping {
        fieldName
        function
        includeGrandTotal
      }
      pageLayout {
        pageFormat
        pageHeight
        pageWidth
        pageOrientation
        pageMargins
        marginTop
        marginBottom
        marginLeft
        marginRight
        fontName
        fontStyle
        fontSize
      }
      distribution {
        emailRecipients {
          email
        }
        emailFrom
        emailSubject
        emailText
        emailAttachments
      }
      schedule {
        scheduleActive
        recurrenceTimePeriod
        recurrenceInterval
        recurrencePeriods
        recurrenceDayNumber
        recurrenceDate
        scheduleStartDate
        scheduleEndDate
      }
      createdBy
      createdAtAgo
      updatedAtAgo
      createdAt(format: "ddd mmm dd yyyy h:MM:ss TT Z")
      updatedAt(format: "ddd mmm dd yyyy h:MM:ss TT Z")
    }
  }
`;

export const UPDATE_DISTRICT_REPORT = gql`
  mutation updateDistrictReport($id: ID!, $districtReportInput: DistrictReportInput) {
    updateDistrictReport(id: $id, districtReportInput: $districtReportInput) {
      id
      districtId
      userId
      isUserReport
      baseReportId
      reportCode
      reportName
      reportTitle
      reportGroup
      reportNotes
      reportRowNotes {
        rowId
        notes
      }
      reportParameters
      selectedFields {
        fieldName
        fieldGroup
        fieldCaption
        fieldOrder
        fieldWidth
        fieldAlignment
        dataType
        dataFormat        
        fieldHasFilter
        fieldHasSort
        visible
        default
        required
      }
      reportColumns
      reportTableFilters,
      reportTableSorter,
      grouping {
        fieldName
        function
        includeGrandTotal
      }
      pageLayout {
        pageFormat
        pageHeight
        pageWidth
        pageOrientation
        pageMargins
        marginTop
        marginBottom
        marginLeft
        marginRight
        fontName
        fontStyle
        fontSize
      }
      distribution {
        emailRecipients {
          email
        }
        emailFrom
        emailSubject
        emailText
        emailAttachments
      }
      schedule {
        scheduleActive
        recurrenceTimePeriod
        recurrenceInterval
        recurrencePeriods
        recurrenceDayNumber
        recurrenceDate
        scheduleStartDate
        scheduleEndDate
      }
      createdBy
      createdAtAgo
      updatedAtAgo
      createdAt(format: "ddd mmm dd yyyy h:MM:ss TT Z")
      updatedAt(format: "ddd mmm dd yyyy h:MM:ss TT Z")
    }
  }
`;

export const DELETE_DISTRICT_REPORT = gql`
  mutation deleteDistrictReport($id: ID!) {
    deleteDistrictReport(id: $id)
  }
`;

export const UPDATE_DISTRICT_REPORT_PAGELAYOUT = gql`
  mutation updateDistrictReport($id: ID!, $districtReportInput: DistrictReportInput) {
    updateDistrictReport(id: $id, districtReportInput: $districtReportInput) {
      id
      pageLayout {
        pageFormat
        pageHeight
        pageWidth
        pageOrientation
        pageMargins
        marginTop
        marginBottom
        marginLeft
        marginRight
        fontName
        fontStyle
        fontSize
      }
    }
  }
`;